import React, { useEffect } from 'react';

interface IframeProps {
  iframeSrc: string;
  iframeTitle: string;
  onClose: () => void;
}

export function IframePopupComponent({ iframeSrc, iframeTitle, onClose }: IframeProps) {
  useEffect(() => {
    // Function to handle key press events
    const handleKeyPress = (event: { key: string; }) => {
      if (event.key === 'Escape') {
        onClose(); // Call onClose which should handle hiding the popup
      }
    };

    // Add event listener when the component mounts
    document.addEventListener('keydown', handleKeyPress);

    // Remove event listener on cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [onClose, iframeSrc]);

  return (
    <div>
      {/* Render the iframe as a popup only if iframeSrc is not empty */}
      {iframeSrc && (
        <div style={{
          display: 'flex',
          position: 'fixed',
          top: '10%',
          left: '10%',
          right: '10%',
          bottom: '10%',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: '1px solid #ccc',
          zIndex: 1000,
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          boxSizing: 'border-box',
          overflow: 'auto',
        }}
        >
          <iframe
            title={iframeTitle}
            src={iframeSrc}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
          <button
            type="submit"
            onClick={onClose}
            style={{
              position: 'absolute',
              top: 20,
              right: 20,
              cursor: 'pointer',
            }}
          >
            x
          </button>
        </div>
      )}
    </div>
  );
}
